module.exports = __webpack_public_path__ + "img/carousel_bg4.e545a44c.png";